import * as React from 'react';

interface DriverJobsSiteArrivalProps {
    truckId: number;
    arrivalCheck: ArrivalCheck;
    back(): void;
    updateDetails(arrivalCheck: ArrivalCheck): void;
    save(): void;
}

interface DriverJobsSiteArrival {
    loading: boolean;
    errors: any;
}

interface ArrivalCheck {
    id: number;
    hazardsRemoved: number;
    workAreasChecked: number;
    layoutPlanMaterialsAvailable: number;
    siteDamage: number;
    siteDamageNotes: string;
}

export default class DriverJobsSiteArrivalData extends React.Component<DriverJobsSiteArrivalProps, DriverJobsSiteArrival> {
    constructor(props: DriverJobsSiteArrivalProps) {
        super(props);

        this.state = {
            loading: false,
            errors: {}
        };
    }

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    back = (e: any) => {
        e.preventDefault();

        this.props.back();
    }

    handleChange = (e: any) => {
        //check if there is a value and an error, and if so remove from error list
        var errors = this.state.errors;
        if (e.target.value) {
            delete errors[e.target.name];
            let notes = e.target.name + "Notes";
            delete errors[notes];
        }

        let arrivalCheck = this.props.arrivalCheck;
        let change: any = {};
        change = arrivalCheck;
        change[e.target.name] = e.target.value * 1;
        this.setState({ errors: errors });
        this.props.updateDetails(arrivalCheck);
    }

    handleChangeText = (e: any) => {
        //check if there is a value and an error, and if so remove from error list
        var errors = this.state.errors;
        if (e.target.value) {
            delete errors[e.target.name];
        }

        let arrivalCheck = this.props.arrivalCheck;
        let change: any = {};
        change = arrivalCheck;
        change[e.target.name] = e.target.value;
        this.setState({ errors: errors });
        this.props.updateDetails(arrivalCheck);
    }

    validate = () => {
        let fields = this.props.arrivalCheck;
        let errors: any = {};
        let formIsValid = true;

        if (fields.hazardsRemoved < 0) {
            formIsValid = false;
            errors["hazardsRemoved"] = "Hazard Removed check is required";
        }

        if (fields.workAreasChecked < 0) {
            formIsValid = false;
            errors["workAreasChecked"] = "Work Area Checked is required";
        }

        if (fields.layoutPlanMaterialsAvailable < 0) {
            formIsValid = false;
            errors["layoutPlanMaterialsAvailable"] = "Layout Plan & Materials Available is required";
        }

        if (fields.siteDamage < 0) {
            formIsValid = false;
            errors["siteDamage"] = "Site Damage is required";
        } else if (fields.siteDamage === 1 && !fields.siteDamageNotes) {
            formIsValid = false;
            errors["siteDamageNotes"] = "Site Damage Notes are required";
        }

        this.setState({ errors: errors });
        return formIsValid;
    }

    save = (e: any) => {
        e.preventDefault();

        if (this.validate()) {
            this.props.save();
        }
    }

    render() {
        let contents = this.state.loading
            ? <p><em>Loading...</em></p>
            : this.renderDetails();

        return <div>
            {contents}
        </div>;
    }

    renderDetails = () => {
        var arrivalCheck = this.props.arrivalCheck;
        let callSupervisor = arrivalCheck.hazardsRemoved === 0 || arrivalCheck.workAreasChecked === 0 || arrivalCheck.layoutPlanMaterialsAvailable === 0 ? true : false;

        return (
            <div>
                <div className="mobileFont marginTop10 marginBottom10">
                    <div className="makeitflexspacebetween marginBottom10">
                        <h4 className="mobile-margin">Arrival Checks</h4>
                        <i className="mobile-icon-grey fas fa-arrow-alt-circle-left mobileMenuSize" onClick={(e) => this.back(e)}></i>
                    </div>

                    <label className="input-group makeitflexspacebetween alignitemscentre truckcheck-background" htmlFor="hazardsRemoved">
                        <span className="label-mobile--inline margin5">Have all Hazards been removed or isolated from working areas? i.e. Trip Hazards etc</span>
                        <input type="radio" id="yes" name="hazardsRemoved" value={1} checked={arrivalCheck.hazardsRemoved === 1} onChange={(e) => this.handleChange(e)}></input>
                        <span className="makeitflex makeitcentervertical marginLeft10 marginRight10">Yes</span>
                        <input type="radio" id="no" name="hazardsRemoved" value={0} checked={arrivalCheck.hazardsRemoved === 0} onChange={(e) => this.handleChange(e)}></input>
                        <span className="makeitflex makeitcentervertical marginLeft10">No</span>
                    </label>
                    <span className={this.state.errors["hazardsRemoved"] ? "label errors" : "hidden"}>{this.state.errors["hazardsRemoved"]}</span>

                    <label className="input-group makeitflexspacebetween alignitemscentre truckcheck-background" htmlFor="workAreasChecked">
                        <span className="label-mobile--inline margin5">Have all work areas been checked and are safe/structurally adequate to support scaffold?</span>
                        <input type="radio" id="yes" name="workAreasChecked" value={1} checked={arrivalCheck.workAreasChecked === 1} onChange={(e) => this.handleChange(e)}></input>
                        <span className="makeitflex makeitcentervertical marginLeft10 marginRight10">Yes</span>
                        <input type="radio" id="no" name="workAreasChecked" value={0} checked={arrivalCheck.workAreasChecked === 0} onChange={(e) => this.handleChange(e)}></input>
                        <span className="makeitflex makeitcentervertical marginLeft10">No</span>
                    </label>
                    <span className={this.state.errors["workAreasChecked"] ? "label errors" : "hidden"}>{this.state.errors["workAreasChecked"]}</span>

                    <label className="input-group makeitflexspacebetween alignitemscentre truckcheck-background" htmlFor="layoutPlanMaterialsAvailable">
                        <span className="label-mobile--inline margin5">Check layout plan works and all required material is available onsite.</span>
                        <input type="radio" id="yes" name="layoutPlanMaterialsAvailable" value={1} checked={arrivalCheck.layoutPlanMaterialsAvailable === 1} onChange={(e) => this.handleChange(e)}></input>
                        <span className="makeitflex makeitcentervertical marginLeft10 marginRight10">Yes</span>
                        <input type="radio" id="no" name="layoutPlanMaterialsAvailable" value={0} checked={arrivalCheck.layoutPlanMaterialsAvailable === 0} onChange={(e) => this.handleChange(e)}></input>
                        <span className="makeitflex makeitcentervertical marginLeft10">No</span>
                    </label>
                    <span className={this.state.errors["layoutPlanMaterialsAvailable"] ? "label errors" : "hidden"}>{this.state.errors["layoutPlanMaterialsAvailable"]}</span>
                    <span className={callSupervisor ? "label errors" : "hidden"}>Please call your supervisor for instructions.</span>

                    <label className="input-group makeitflexspacebetween alignitemscentre truckcheck-background" htmlFor="siteDamage">
                        <span className="label-mobile--inline margin5">Is there any damage to the Site?</span>
                        <input type="radio" id="yes" name="siteDamage" value={1} checked={arrivalCheck.siteDamage === 1} onChange={(e) => this.handleChange(e)}></input>
                        <span className="makeitflex makeitcentervertical marginLeft10 marginRight10">Yes</span>
                        <input type="radio" id="no" name="siteDamage" value={0} checked={arrivalCheck.siteDamage === 0} onChange={(e) => this.handleChange(e)}></input>
                        <span className="makeitflex makeitcentervertical marginLeft10">No</span>
                    </label>
                    <span className={this.state.errors["siteDamage"] ? "label errors" : "hidden"}>{this.state.errors["siteDamage"]}</span>

                    <label className={arrivalCheck.siteDamage === 1 ? "input-group makeitflexspacebetween truckcheck-background" : "hidden"} htmlFor="siteDamageNotes">
                        <span className="label-mobile--inline margin5">Notes</span>
                        <input className="input--mobile margin5" maxLength={200} type="text" id="siteDamageNotes" name="siteDamageNotes" value={arrivalCheck.siteDamageNotes} onChange={(e) => this.handleChangeText(e)}></input>
                    </label>
                    <span className={this.state.errors["siteDamageNotes"] ? "label errors" : "hidden"}>{this.state.errors["siteDamageNotes"]}</span>

                    <div className="defaultbutton__container--right marginTop10">
                        <i className="mobile-icon-green fas fa-arrow-alt-circle-right mobileMenuSize" onClick={(e) => this.save(e)}></i>
                    </div>

                </div>
            </div>
        );

    }
}
